const currencies = [
  'SEK',
  'EUR',
];

export default currencies;
